import React from 'react';
import Link from 'next/link';
import { Card } from '@/components/card';

interface ForgeTypeCardProps {
    icon: React.ReactNode;
    text: string;
    href: string;
    disabled: boolean;
}

export const ForgeTypeCard = ({ icon, text, href, disabled }: ForgeTypeCardProps) => {
    if (disabled) {
        return (
            <Card className="!w-[190px]" disabled={true} >
                <div className="flex flex-col items-center gap-1.5">
                    {icon}
                    <p className="text-sm">{text}</p>
                </div>
            </Card>
        );
    }
    return (
        <Link href={href}>
            <Card className="hover:bg-[#0133BC] hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] active:shadow-[4px_4px_14px_0px_rgba(0,0,0,0.32)_inset,_0px_2px_8px_0px_rgba(0,0,0,0.04)] hover:border-[#4E7DFF] !w-[190px] text-[#364152] hover:text-white">
                <div className="flex flex-col items-center gap-1.5">
                    {icon}
                    <p className="text-sm">{text}</p>
                </div>
            </Card>
        </Link>
    );
};